import { getPricingPlanCopy } from "../utils/pricingPlanContent";

function FeatureIcon({ included }) {
    if (included) {
        return (
            <svg className="pricing-plan-icon pricing-plan-icon--yes" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M20 6L9 17l-5-5"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }
    return (
        <svg className="pricing-plan-icon pricing-plan-icon--no" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default function PricingPlanCard({ plan, action }) {
    const copy = getPricingPlanCopy(plan);
    if (!copy) return null;

    return (
        <article className={`pricing-plan-card${copy.featured ? " pricing-plan-card--featured" : ""}`}>
            <h3 className="pricing-plan-title">{copy.title}</h3>
            <p className="pricing-plan-tagline">{copy.tagline}</p>
            <hr className="pricing-plan-divider" />
            <div className="pricing-plan-price">
                {copy.priceNote && (
                    <p className="pricing-plan-price-note">
                        {copy.priceNote.replace(/\*$/, "")}
                        {copy.priceNote.endsWith("*") && <span className="pricing-plan-mark">*</span>}
                    </p>
                )}
                <div className="pricing-plan-price-row">
                    <span className="pricing-plan-price-main">{copy.priceMain}</span>
                    {copy.priceSub && <span className="pricing-plan-price-sub">{copy.priceSub}</span>}
                </div>
            </div>
            <ul className="pricing-plan-features">
                {copy.features.map((feature) => (
                    <li key={feature.label} className="pricing-plan-feature">
                        <span>
                            {feature.label}
                            {feature.mark && <span className="pricing-plan-mark">{feature.mark}</span>}
                        </span>
                        <FeatureIcon included={feature.included} />
                    </li>
                ))}
            </ul>
            {copy.terms.length > 0 && (
                <div className="pricing-plan-terms">
                    <h4>Terms & Conditions</h4>
                    <ul>
                        {copy.terms.map((term) => (
                            <li key={term.mark}>
                                <span className="pricing-plan-mark">{term.mark}</span> {term.text}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            {action}
        </article>
    );
}
